
export default class Accordion{
    constructor(node){
        this.accordions = node;
        this.accordionItems = this.accordions.querySelectorAll('.accordion-item');
        this.listeners = []

        this.initAccordions()
    }

    initAccordions() {
		// console.debug('  -> Accordions init')

		this.accordionItems.forEach((accordionItem) => {
            let accordionButton = accordionItem.querySelector('.accordion-title');

            const clickHandler = () => {
                if( !accordionItem.classList.contains('open') ){
                    this.accordionItems.forEach((accordion) => {
                        accordion.classList.remove('open')
                        if( accordion !== accordionItem ) accordion.querySelector('.accordion-hidden-section').style.display = 'none'
                    })
                    accordionItem.querySelector('.accordion-hidden-section').style.display = 'block'
                    setTimeout(() => {
                        accordionItem.classList.add('open')
                    }, 250)
                } else {
                    accordionItem.classList.remove('open')
                    setTimeout(() => {
                        accordionItem.querySelector('.accordion-hidden-section').style.display = 'none'
                    }, 500)
                }
            }

            // Adding event listener to array
            accordionButton.addEventListener('click', clickHandler)
            this.listeners.push({ button: accordionButton, handler: clickHandler });
        })
    }

    destroy() {
        // console.debug('  -> Destroying Accordions');
        this.listeners.forEach(({ button, handler }) => {
            button.removeEventListener('click', handler)
        })
        this.listeners = []
    }

    static handleUrlHash() {
        const hash = window.location.hash.substring(1); // Retrieving id without hash
        if (hash ){
            const targetAccordionItem = document.getElementById(hash);
            if( targetAccordionItem && targetAccordionItem.classList.contains('accordion-item') ){
                const targetButton = targetAccordionItem.querySelector('.accordion-title')

                if( targetButton ){
                    if( !targetAccordionItem.classList.contains('open') ){
                        targetButton.click()
                    }

                    setTimeout(() => {
                        targetButton.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        })
                    }, 300)
                }
            }
        }
    }

    static initCtaButtonListeners() {
        const ctaButtons = document.querySelectorAll('a.btn--cta[href^="#"]')

        ctaButtons.forEach(button => {
            button.addEventListener('click', (event) => {
                event.preventDefault()

                const newHash = button.getAttribute('href')

                if( window.location.hash !== newHash ){
                    window.location.hash = newHash
                } else {
                    Accordion.handleUrlHash()
                }
            })
        })
    }

    static reset() {
        // console.debug('  -> Resetting accordion components')
        if (Accordion.items) {
            Accordion.items.forEach(item => item.destroy())
        }
        Accordion.init()
    }

    static init() {
        // console.debug('  -> Initializing accordion components');
        Accordion.items = Array.from(document.querySelectorAll('.accordion')).map(
            (accordions) => new Accordion(accordions)
        )
        // Initalizing listener to open Accordion with url hash
        Accordion.handleUrlHash()
        // Adding listener for hashchange event
        window.addEventListener('hashchange', Accordion.handleUrlHash)
         // Initializing listener for CTA buttons
        Accordion.initCtaButtonListeners()
    }
}